<template>
  <div class="flex h-dvh flex-col items-center gap-4 overflow-hidden print:overflow-visible!">
    <header class="w-full print:hidden">
      <NavbarLayout />
    </header>
    <main
      class="flex grow flex-col overflow-y-auto"
      :class="route.meta.width ?? 'container print:mx-0 print:min-w-full'"
    >
      <RouterView />
    </main>
  </div>
</template>

<script setup lang="ts">
import { RouterView, useRoute } from 'vue-router';
import NavbarLayout from './NavbarLayout.vue';

const route = useRoute();
</script>
